import React, { Children } from "react";
import { VagaroIcon } from "./Icons/SocialIcons";
import { GetGlobalCurrentPageData } from "./Utilities/WindowUtils";

export default function OopsBanner() {

    return <div className="center-all" style={{padding:"12px",margin:"12px",borderRadius:"5px",color:"white",background:"#B42318",width:"calc(100% - 24px)",wordBreak:"break-word"}}>
    Oops! Something went wrong. Please try again later.
    </div>

}

export function NoRecordsBanner({message,children,showInLive,vagaroLink,linkText}:{children?:any,message?:string,showInLive?:boolean,vagaroLink?:string,linkText?:string}){

    let msg = message??"No Records Found"
    let isEditor = (window as any).isEditor === true;
    let newLink = vagaroLink;


    if(GetGlobalCurrentPageData().isDuplicateAllLocationPage){

        if(!showInLive){
            showInLive = true;
            if(!isEditor)
                newLink = undefined;
            if(!message){
                msg = "Not Available at This Location."
            }
        }
    }   

    if(newLink){
        if(!window.location.hostname.includes('mysite.vagaro.com')){
            newLink = newLink.replace('www.vagaro.com','dev24.bookitall.com');
           }
    }



    if(!isEditor&&!showInLive){
        return null;
    }

    return <div className="v-button secondary flex-column justify-center align-center" style={{pointerEvents:"none",padding:"12px",margin:"12px",borderRadius:"5px",width:"calc(100% - 24px)",wordBreak:"break-word"}}>
   {msg}
   {
    isEditor&&!showInLive&&
    <>
    <div className="font-small" style={{opacity:".7",fontWeight:"bold"}}>This message will be hidden on your published site.</div>
    {newLink&&
    <button className="w-button w-button-primary center-all gap-med" style={{marginTop:"12px",pointerEvents:"all"}} onClick={()=>{
        
            window.open(newLink)
        }
    }>{linkText??"Edit in Vagaro"}<VagaroIcon/></button> }
  
    </>
    }
      {children}
    </div>
    
}


function IsOnDuplicatePage(){

    let currentPage = GetGlobalCurrentPageData();
    



}